export function isValueInStringEnum<E extends string>(
  stringEnum: Record<string, E>
) {
  const enumValues = Object.values(stringEnum) as string[];
  return (value: string): value is E => enumValues.includes(value);
}
